// ── Brand & contact configuration ─────────────────────────────
export const BRAND = {
  name: "K2 GUINCHO 24H",
  phoneDisplay: "(11) 99243-1030",
  phoneRaw: "+5511992431030",
  whatsappNumber: "5511992431030",
  address: {
    street: "Rua Curuena, 212",
    district: "Chácara Belenzinho",
    city: "São Paulo - SP",
    cep: "CEP 03380-160",
  },
  logo:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_dan-guincho/artifacts/96oaj9fx_ChatGPT_Image_30_de_jul._de_2026__09_29_42-removebg-preview.png",
};

const DEFAULT_MSG =
  "Olá K2 GUINCHO 24H! Preciso de um guincho.\n\n📍 Localização: \n🚗 Modelo do veículo: \n⚠️ Problema: ";

export const waLink = (msg = DEFAULT_MSG) =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;
export const telLink = `tel:${BRAND.phoneRaw}`;

// ── Images ────────────────────────────────────────────────────
export const IMAGES = {
  // Guincho Hyundai HD78 plataforma — nova foto do hero
  heroNight:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_dan-guincho/artifacts/pdaou17h_WhatsApp%20Image%202026-07-28%20at%2020.40.54.jpeg",
  // Silver SUV loaded daytime
  suvDay:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_76387649-ffba-4b96-8d5c-ebf8c37c1c70/artifacts/meae6off_WhatsApp%20Image%202026-07-28%20at%2020.44.16.jpeg",
  // Empty flatbed ramp lowered, ready
  rampReady:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_76387649-ffba-4b96-8d5c-ebf8c37c1c70/artifacts/cj788koq_WhatsApp%20Image%202026-07-28%20at%2020.42.42.jpeg",
  // Black pickup loaded on flatbed, street
  pickupStreet:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_76387649-ffba-4b96-8d5c-ebf8c37c1c70/artifacts/tajn6u6o_WhatsApp%20Image%202026-07-28%20at%2020.40.55.jpeg",
};

// ── Hero rating badges ────────────────────────────────────────
export const RATINGS = [
  "Atendimento Rápido",
  "24 Horas",
  "Automóveis e Motos",
  "Chegada Ágil",
];

// ── Services ──────────────────────────────────────────────────
export const SERVICES = [
  {
    icon: "Car",
    title: "Guincho para Automóveis",
    desc: "Remoção segura de veículos leves com plataforma moderna e amarração profissional.",
  },
  {
    icon: "Bike",
    title: "Guincho para Motocicletas",
    desc: "Equipamentos próprios para transporte de motos com total proteção contra danos.",
  },
  {
    icon: "Clock",
    title: "Socorro 24 Horas",
    desc: "Atendimento dia e noite, todos os dias, incluindo finais de semana e feriados.",
  },
  {
    icon: "Truck",
    title: "Transporte de Veículos",
    desc: "Remoções particulares de carros para qualquer destino na Grande São Paulo.",
  },
  {
    icon: "Wrench",
    title: "Remoção para Oficinas",
    desc: "Levamos seu veículo até a oficina desejada com rapidez e segurança.",
  },
  {
    icon: "Gavel",
    title: "Transporte para Leilões",
    desc: "Atendimento para Sodré Santoro e Freitas Leilões com pontualidade garantida.",
  },
];

// ── Differentials ─────────────────────────────────────────────
export const DIFFERENTIALS = [
  "Atendimento 24 horas",
  "Chegada rápida",
  "Motoristas experientes",
  "Guinchos modernos",
  "Transporte seguro",
  "Atendimento via WhatsApp",
  "Orçamento imediato",
  "Cobertura em toda Zona Leste",
];

// ── How it works ──────────────────────────────────────────────
export const STEPS = [
  { n: "01", title: "Entre em contato", desc: "Chame nossa equipe pelo WhatsApp ou ligue direto." },
  { n: "02", title: "Envie sua localização", desc: "Compartilhe o ponto exato onde você está." },
  { n: "03", title: "Informe o modelo", desc: "Diga qual é o veículo a ser removido." },
  { n: "04", title: "Informe o problema", desc: "Explique rapidamente o que aconteceu." },
  { n: "05", title: "Receba o orçamento", desc: "Nossa equipe envia o preço na hora." },
  { n: "06", title: "Guincho a caminho", desc: "O reboque é deslocado imediatamente até você." },
];

// ── Testimonials ──────────────────────────────────────────────
export const TESTIMONIALS = [
  { text: "Excelente atendimento.", author: "Cliente Google" },
  { text: "Chegou muito rápido.", author: "Cliente Google" },
  { text: "Preço justo.", author: "Cliente Google" },
  { text: "Motorista muito educado.", author: "Cliente Google" },
  { text: "Serviço impecável.", author: "Cliente Google" },
];

// ── SEO areas: unique natural text per neighborhood ───────────
export const AREAS = [
  { name: "Aricanduva", text: "Guincho no Aricanduva com chegada expressa próximo ao shopping e às principais avenidas do bairro." },
  { name: "Carrão", text: "Reboque no Carrão para carros e motos, cobrindo ruas residenciais e o comércio local." },
  { name: "Vila Formosa", text: "Atendimento de guincho na Vila Formosa a qualquer hora, com equipe que conhece cada esquina da região." },
  { name: "Tatuapé", text: "Guincho no Tatuapé rápido e seguro, atuando perto dos shoppings e do coração comercial da Zona Leste." },
  { name: "Vila Ema", text: "Socorro automotivo na Vila Ema com plataforma moderna para remoção sem riscos." },
  { name: "Vila Prudente", text: "Reboque na Vila Prudente com deslocamento ágil pelas vias que ligam a região ao centro." },
  { name: "São Mateus", text: "Guincho em São Mateus disponível 24 horas para emergências em toda a extensão do distrito." },
  { name: "Água Rasa", text: "Atendimento na Água Rasa com motoristas experientes e transporte totalmente seguro." },
  { name: "Chácara Belém", text: "Guincho na Chácara Belém, nossa vizinhança, com o menor tempo de chegada da região." },
  { name: "Chácara Mafalda", text: "Reboque na Chácara Mafalda para veículos leves e motocicletas com orçamento imediato." },
  { name: "Cangaíba", text: "Guincho no Cangaíba cobrindo ruas próximas à Marginal com agilidade e preço justo." },
  { name: "Itaquera", text: "Atendimento em Itaquera perto da arena e do terminal, com equipe pronta a qualquer hora." },
  { name: "Cidade A. E. Carvalho", text: "Guincho na Cidade A. E. Carvalho com socorro rápido para autos e motos." },
  { name: "Cidade Líder", text: "Reboque na Cidade Líder com deslocamento imediato para toda a redondeza." },
  { name: "Patriarca", text: "Guincho no Patriarca operando dia e noite com segurança e cuidado no transporte." },
  { name: "Vila Matilde", text: "Atendimento na Vila Matilde próximo ao metrô, com chegada veloz até você." },
  { name: "COHAB Itaquera", text: "Guincho na COHAB Itaquera para remoções particulares e emergências urbanas." },
  { name: "Mooca", text: "Reboque na Mooca com equipe que domina o trânsito do bairro para chegar mais rápido." },
  { name: "Penha", text: "Guincho na Penha 24 horas, cobrindo do centro do bairro às margens da Radial Leste." },
  { name: "Penha de França", text: "Atendimento na Penha de França com transporte seguro de carros e motos." },
  { name: "Ponte Rasa", text: "Guincho na Ponte Rasa com socorro ágil próximo à Marginal Tietê." },
  { name: "Vila Alzira", text: "Reboque na Vila Alzira para veículos leves com amarração profissional." },
  { name: "Vila Antonieta", text: "Guincho na Vila Antonieta disponível a qualquer momento, com orçamento na hora." },
  { name: "Vila Bertioga", text: "Atendimento na Vila Bertioga com plataforma moderna e motoristas de confiança." },
  { name: "Vila Califórnia", text: "Guincho na Vila Califórnia com chegada rápida em ruas residenciais e avenidas." },
  { name: "Vila Carmosina", text: "Reboque na Vila Carmosina próximo a Itaquera, pronto para emergências 24h." },
  { name: "Santa Clara", text: "Guincho no Jardim Santa Clara com atendimento seguro para autos e motocicletas." },
  { name: "Arthur Alvim", text: "Atendimento em Arthur Alvim com deslocamento imediato para toda a vizinhança." },
  { name: "Vila Guilhermina", text: "Guincho na Vila Guilhermina perto do metrô, com socorro veloz e preço justo." },
  { name: "Brás", text: "Reboque no Brás cobrindo o polo comercial com agilidade mesmo no trânsito intenso." },
  { name: "Vila Cisper", text: "Guincho na Vila Cisper com transporte cuidadoso de veículos leves." },
  { name: "Assis Ribeiro", text: "Atendimento na região da Av. Assis Ribeiro com chegada rápida junto à Marginal." },
  { name: "Parque Novo Mundo", text: "Guincho no Parque Novo Mundo com socorro imediato próximo às vias expressas." },
  { name: "Marginal Tietê", text: "Reboque na Marginal Tietê para panes e emergências ao longo de toda a via." },
  { name: "Sodré Santoro", text: "Transporte de veículos até o pátio da Sodré Santoro com pontualidade garantida." },
  { name: "Freitas Leilões", text: "Guincho para o Freitas Leilões com remoção segura e no horário combinado." },
  { name: "Rua Taubaté", text: "Atendimento na Rua Taubaté e adjacências com equipe pronta 24 horas." },
  { name: "Jardim Aricanduva", text: "Guincho no Jardim Aricanduva com chegada expressa para autos e motos." },
  { name: "Jardim Vila Formosa", text: "Reboque no Jardim Vila Formosa com transporte seguro e orçamento imediato." },
  { name: "Vila Dalila", text: "Guincho na Vila Dalila operando dia e noite com motoristas experientes." },
  { name: "Vila Savóia", text: "Atendimento na Vila Savóia com plataforma moderna e chegada ágil." },
  { name: "Anhaia Mello", text: "Guincho na Av. Anhaia Mello com socorro rápido em toda a extensão da avenida." },
  { name: "Salim Farah Maluf", text: "Reboque na Av. Salim Farah Maluf para emergências junto à Radial e Marginal." },
];

// ── Nav links ─────────────────────────────────────────────────
export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Serviços", href: "#servicos" },
  { label: "Áreas Atendidas", href: "#areas" },
  { label: "Galeria", href: "#galeria" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" },
];
